<template>
  <HomeV2 v-if="useNewHome" />
  <Home v-else />
</template>

<script setup>
/**
 * Despachador de la home: sirve Home.vue (la clásica) cuando estamos en el
 * hostname de producción, y HomeV2.vue en cualquier otro (pre, local,
 * previews).
 *
 * Se importan ambos componentes estáticamente para evitar mismatches de
 * hidratación: durante SSG (sin window) se prerrenderiza Home.vue, y tras
 * montar en cliente se hace el switch a HomeV2 cuando corresponde. El
 * usuario de pre verá un destello mínimo al hidratar — asumible para
 * testers internos. Los usuarios de producción nunca ven el switch.
 *
 * Cuando la V2 esté lista para producción, basta con cambiar
 * `home: HomeDispatcher` por `home: HomeV2` en el componentMap del router
 * y eliminar este archivo.
 */
import { ref, onMounted } from "vue";
import Home from "./Home.vue";
import HomeV2 from "./HomeV2.vue";
import { isProductionHost } from "@/utils/env";

const useNewHome = ref(false);

onMounted(() => {
  if (!isProductionHost()) useNewHome.value = true;
});
</script>
